<template>
  <div class="layout">
    <page-header />
    <empty-view v-if="showError" :showdata="showdata" />
    <div class="body-root">
      <div :class="ISPC ? 'content-root' : 'content-root-mobile'" v-if="!showError && articleItem">
        <article-detail-content :item="articleItem" @refreshData="getDetailData()" />
        <article-detail-comment :item="articleItem" @submitComment="submitComment" />
        <article-detail-comment-list :commentList="commentList" />
      </div>
      <div style="position:absolute;width: 160px;height: 140px;right: 0;top: 0;" v-if="ISPC">
        <div style="padding: 12px;background-color: #fff;border: 1px solid #e0e0e0;text-align:center;">
          <img :src="kerunHeader" style="width: 90px;height: 90px;border-radius: 90px;" />
          <br />
          <br />
          <span style="color:#666;font-size: 14px;">南京科润</span>
        </div>
        <el-button :type="hasSigned ? 'info' : 'primary'" style="width:100%;margin-top: 20px;" @click="openCheck">{{
          hasSigned ? '已签到' : '签到'
        }}</el-button>
      </div>
    </div>
    <page-footer />
    <check-module :checkModuleFalg="checkModuleFalg" @closeModule="closeModule()" />
  </div>
</template>
<script>
import PageHeader from '@/components/header/PageHeader'
import PageFooter from '@/components/footer/PageFooter'
import EmptyView from '@/components/empty/EmptyView'
import ArticleDetailContent from './modules/ArticleDetailContent'
import ArticleDetailComment from './modules/ArticleDetailComment'
import ArticleDetailCommentList from './modules/ArticleDetailCommentList'
import xyAPI from '@/api/xyAPI'
import loadData from '@/https/loadData'
import v1 from '@/assets/imgs/v1.png'
import v2 from '@/assets/imgs/v2.png'
import v3 from '@/assets/imgs/v3.png'
import v4 from '@/assets/imgs/v4.png'
import kerunHeader from '@/assets/imgs/kerun-header.png'
import CheckModule from './modules/CheckModule'
import xy_config from '@/config/xy_config'
export default {
  name: 'ArticleDetail',
  components: {
    PageHeader,
    PageFooter,
    EmptyView,
    ArticleDetailContent,
    ArticleDetailComment,
    ArticleDetailCommentList,
    CheckModule
  },
  computed: {
    ISPC() {
      if (/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent)) {
        //移动端
        return false
      }
      return true
    },
    hasSigned() {
      return this.$store.getters.hasSigned
    }
  },
  data() {
    return {
      articleid: null,
      articleItem: null,
      showError: false,
      commentList: [],
      headers: [
        {
          key: 'v1',
          img: v1
        },
        {
          key: 'v2',
          img: v2
        },
        {
          key: 'v3',
          img: v3
        },
        {
          key: 'v4',
          img: v4
        }
      ],
      hs: {},
      hIndex: 0,
      kerunHeader: kerunHeader,
      showdata: null,
      checkModuleFalg: false
    }
  },
  created() {
    const _that = this
    const aId = _that.$route.query.id
    if (aId) {
      _that.articleid = aId
      // 去获取数据
      _that.getDetailData()
    } else {
      _that.showError = true
    }
  },
  methods: {
    closeModule() {
      this.checkModuleFalg = false
    },
    openCheckModule() {
      this.checkModuleFalg = true
    },
    openCheck() {
      const _that = this
      const tokenCookie = this.$cookie.get(xy_config.cookieToken)
      if (!tokenCookie) {
        _that.$message({
          message: '登录后操作',
          duration: 1000,
          onClose: () => {
            window.location.href = '../login/login.html?to=' + escape(window.location.href)
          }
        })
        return
      }
      this.openCheckModule()
    },
    async getDetailData() {
      const _that = this
      const tokenCookie = this.$cookie.get(xy_config.cookieToken)
      try {
        const res = await loadData(xyAPI.getArticleInfo, { articleid: _that.articleid })
        if (res && String(res.code) === '0' && res.data) {
          if (res.data.class === '2' && !tokenCookie) {
            _that.$alert('积分兑换文章需要登录之后才能查看', '提示', {
              confirmButtonText: '去登录',
              showCancelButton: true,
              callback: action => {
                if (action === 'confirm') {
                  // 跳转登录
                  _that.$message({
                    message: '登录后操作',
                    duration: 1000,
                    onClose: () => {
                      window.location.href = '../login/login.html?to=' + escape(window.location.href)
                    }
                  })
                }
              }
            })
          }else {
            _that.showError = false
            _that.articleItem = { ...res.data }
            _that.getCommentData()
          }
        } else if (res && String(res.code) === '-1') {
          _that.$alert('文章未兑换，需要积分兑换之后才能查看', '提示', {
            confirmButtonText: '去购买',
            showCancelButton: true,
            callback: action => {
              if (action === 'confirm') {
                // 如果没有购买弹出购买提示
                _that.$alert('确认使用积分查看文章?', '提示', {
                  confirmButtonText: '确认',
                  showCancelButton: true,
                  callback: async action => {
                    if (action === 'confirm') {
                      // 调用兑换接口
                      const res = await loadData(xyAPI.userBuyArticle, { articleid: _that.articleid })
                      if (res && String(res.code) === '0') {
                        _that.$message({
                          message: '操作成功'
                        })

                        _that.getDetailData()
                      } else {
                        _that.$message(res && res.msg ? res.msg : '操作失败')
                      }
                    }
                  }
                })
              } else {
                _that.showError = true
                _that.showdata = res && res.msg ? res.msg : '积分兑换文章,暂时无法查看!'
              }
            }
          })
        } else {
          _that.showError = true
          _that.showdata = res && res.msg ? res.msg : '获取文章内容失败,请重试!'
          // _that.$message(res && res.msg ? res.msg : '获取文章内容失败,请重试!')
        }
      } catch (error) {
        _that.showError = true
        _that.showdata = '获取文章内容失败,请重试!'
        // _that.$message('获取文章内容失败,请重试!')
      }
    },
    submitComment() {
      // 提交评论成功,刷新评论页面
      this.getCommentData()
      this.getDetailData()
    },
    async getCommentData() {
      const _that = this
      try {
        const res = await loadData(xyAPI.queryArticleMessageList, { articleid: _that.articleid })
        if (res && String(res.code) === '0' && res.data) {
          const rData = [...res.data]
          rData.map(rItem => {
            const iId = 'i' + rItem.leaveuser
            if (_that.hs[iId]) {
              rItem['headerImg'] = _that.hs[iId]
            } else {
              _that.hIndex = _that.hIndex > 2 ? 0 : _that.hIndex + 1
              const imgT = _that.headers[_that.hIndex].img
              rItem['headerImg'] = imgT
              const hsT = { ..._that.hs }
              hsT[iId] = imgT
              _that.hs = hsT
            }
          })
          _that.commentList = rData
        } else {
          _that.$message(res && res.msg ? res.msg : '获取评论失败')
        }
      } catch (error) {
        _that.$message('获取评论失败')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.layout {
  height: 100vh;
  .body-root {
    width: 1190px;
    min-width: 1190px;
    margin: 0 auto 12px auto;
    position: relative;
    .content-root {
      width: 980px;
      min-width: 980px;
      border: 1px solid #e0e0e0;
      background: #fff;
    }
    .content-root-mobile {
      width: 100%;
      border: 1px solid #e0e0e0;
      background: #fff;
    }
  }
}
</style>
